import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { Button } from 'components'
import { StyledResetButtonContainer } from './utils'

const resetButtonStyles = {
    backgroundColor: '#eef0f4  ',
    color: '#0057A0  ',
    border: '1px solid #0057A0',
    minWidth: '100px !important',
    boxShadow: 'none',
    '&:hover': {
        '& svg': { color: '#ffffff' },
        backgroundColor: '#0057A0',
        color: '#ffffff',
    },
}

export const ResetToDefault = ({ handleReset, resetting }: any) => {
    const { t } = useTranslation()

    const button = (
        <Button.Rounded
            styles={resetButtonStyles}
            loading={resetting}
            disabled={resetting}
            onClick={() => handleReset()}
        >
            {t('ResetAllPreferencesToDefault')}
        </Button.Rounded>
    )

    return (
        <StyledResetButtonContainer data-ai-explain="Reset all notification preferences to their default values">
            {button}

            <Box
                color="#848992"
                fontSize="13px"
                display="flex"
                alignItems="center"
            >
                {t('ResetNotificationsSettings')}
            </Box>
        </StyledResetButtonContainer>
    )
}
